import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Brain, Sigma, Shapes, ArrowRight, Sparkles } from "lucide-react";

const META = {
  verbal: { icon: Brain, label: "Verbale", color: "#002FA7",
    desc: "Deduci l'unica affermazione logicamente compatibile con un passo istituzionale." },
  numerical: { icon: Sigma, label: "Numerico", color: "#0A0F1A",
    desc: "Leggi tabelle con valori assoluti e percentuali e ricava il dato esatto." },
  abstract: { icon: Shapes, label: "Astratto", color: "#002FA7",
    desc: "Individua la regola nascosta in una matrice 3×3 e completa la figura mancante." },
};

export default function FreeHub() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/free").then(r => setCats(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <section className="border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16">
          <div className="label-mono text-[#002FA7] mb-4">— Test gratuito · nessuna registrazione</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-6">
            Prova subito. 12 domande per tipo.
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl leading-relaxed">
            Scegli una prova di ragionamento. Correzione immediata con spiegazione passo-passo di ogni risposta —
            senza creare un account.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="free-hub-cards">
          {["verbal", "numerical", "abstract"].map((cat) => {
            const m = META[cat];
            const info = cats.find((c) => c.category === cat);
            const Icon = m.icon;
            return (
              <div key={cat} data-testid={`free-card-${cat}`}
                className="border border-slate-200 bg-white p-8 flex flex-col hover:shadow-hard transition-all hover:-translate-y-1">
                <div className="flex items-center justify-between mb-6">
                  <Icon className="w-9 h-9" style={{ color: m.color }} strokeWidth={1.5} />
                  <span className="label-mono text-xs bg-[#FFD700] text-[#0A0F1A] px-2 py-1">GRATIS</span>
                </div>
                <h3 className="font-display font-bold text-xl mb-2">Ragionamento {m.label}</h3>
                <p className="text-sm text-slate-600 leading-relaxed flex-1 mb-6">{m.desc}</p>
                <div className="label-mono text-slate-500 mb-4 font-mono-num">
                  {info ? info.num_questions : 12} domande · 15 min
                </div>
                <Link to={`/free/${cat}`}>
                  <Button data-testid={`free-start-${cat}`}
                    className="w-full rounded-none bg-[#002FA7] hover:bg-[#001d6b] text-white label-mono py-6">
                    Inizia <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>
            );
          })}
        </div>

        <div className="mt-12 border border-[#002FA7] bg-[#0A0F1A] text-white p-8 premium-grain flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 label-mono text-[#FFD700] mb-2">
              <Sparkles className="w-4 h-4" /> 450 domande con spiegazione
            </div>
            <p className="text-slate-200 max-w-xl leading-relaxed">
              Sblocca la banca completa: 150 verbali, 150 numeriche e 150 astratte in stile EPSO 2026,
              con correzione e spiegazione algoritmica.
            </p>
          </div>
          <Link to="/pricing">
            <Button data-testid="free-hub-pricing"
              className="rounded-none bg-[#FFD700] hover:bg-white text-[#0A0F1A] label-mono py-6 px-8 whitespace-nowrap">
              Vedi i prezzi
            </Button>
          </Link>
        </div>
      </section>
    </Layout>
  );
}
